<ui-section class="height-100" [title]="cardTitle | translate">
    <ui-section-actions>
        @if (helpLink) {
            <help-button class="medium-margin-left no-print" [link]="helpLink" />
        }
        @if (action && summaryList?.length && rightNeeded | hasRight) {
            <button
                ui-button
                color="primary"
                iconName="go-to"
                buttonStyle="outline"
                size="small"
                class="no-print"
                (click)="actionClick(action)"
            >
                {{ action.title | translate }}
            </button>
        }
    </ui-section-actions>
    <ui-section-content>
        <developer-helper [datasourceCode]="OldDataSourceCode.ACTION" />
        @if (summaryList) {
            @if (summaryList?.length) {
                <div class="scrollable">
                    <div class="grid-container grid-1">
                        @for (listItem of summaryList; track listItem) {
                            <div class="summary-line cursor-hand" (click)="actionClick(listItem)">
                                @if (listItem.avatarImageUrl | asyncFallback) {
                                    <div class="avatar-container">
                                        <ui-avatar [src]="listItem.avatarImageUrl | asyncFallback" />
                                    </div>
                                }
                                <div class="description-container">
                                    <h2 class="item-title">{{ listItem.title | translate: listItem.titleParams }}</h2>
                                    @if (listItem.subtitle) {
                                        <p class="item-subtitle">
                                            @for (sub of listItem.subtitle; track sub; let i = $index) {
                                                <span>
                                                    @if (sub.color) {
                                                        <span class="{{ sub.color }} item-colored-subtitle">{{ sub.text }}</span>
                                                    } @else {
                                                        <span class="item-subtitle">{{ sub.text }}</span>
                                                    }
                                                    @if (i + 1 !== listItem.subtitle.length) {
                                                        <span>-</span>
                                                    }
                                                </span>
                                            }
                                        </p>
                                    }
                                </div>
                                <div class="status-container">
                                    <ui-chip [colorPalette]="listItem.chipColorName | colorPalette">{{ listItem.chipText }}</ui-chip>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            } @else {
                @if (!isLoading) {
                    <div class="no-data medium-padding">
                        <svg-icon src="assets/icons/home/{{ noDataMessage.icon }}.svg" />
                        <h2 class="no-data-title">{{ noDataMessage.title | translate }}</h2>
                        <p class="no-data-subtitle">{{ noDataMessage.subtitle | translate }}</p>
                        @if (noDataMessage.actionBtn && noDataMessage.actionBtn.text && noDataMessage.actionBtn.callback) {
                            <button class="noDataMessagePadding" ui-button color="primary" (click)="noDataMessage.actionBtn.callback()">
                                {{ noDataMessage.actionBtn.text | translate }}
                            </button>
                        }
                    </div>
                }
            }
        }
        <loading-and-error padding [isLoading]="isLoading" [hasError]="hasError" />
    </ui-section-content>
</ui-section>
